<template>
  <div>
    <fg-input>
      <label class="form-label">{{ label || "Zeitraum" }}</label>
      <el-date-picker
        type="datetimerange"
        range-separator="bis"
        start-placeholder="Start"
        end-placeholder="Ende"
        value-format="yyyy-MM-dd HH:mm"
        format="dd.MM.yyyy HH:mm"
        :value="realValue"
        @input="emitFilter"
      >
      </el-date-picker>
    </fg-input>
  </div>
</template>

<script lang="babel">
import { DatePicker } from 'element-ui';
import { FgInput } from "src/components/UIComponents";

export default {
    components: {
      [DatePicker.name]: DatePicker,
      [FgInput.name]: FgInput,
    },
    props: ['value', 'attributes', 'id', 'label'],
    data(){
      return {
        dateField: null,
      }
    },
    computed: {
      realValue() {
        if (!this.value) {
          return null;
        }
        let value = [];

        this.value.forEach(attribute => {
          value.push(attribute.value);
        });

        return value;
      }
    },
    created() {
      if(this.attributes)
        this.dateField = this.attributes.dateField
      else
        this.dateField = 'created_at';
    },
    methods: {
      emitFilter(dateRange) {
        // Avoid emitting null multiple times
        if (this.lastEmittedValue === dateRange) {
          return;
        }

        this.lastEmittedValue = dateRange;

        let filter = { name: 'whereDate', id: this.id };
        if (dateRange) {
          filter.attributes = [
            { column: this.dateField, operator: '>=', value: dateRange[0] },
            { column: this.dateField, operator: '<=', value: dateRange[1] }
          ]
        }
        this.$emit('filter-change', filter);
      }
    }
};
</script>
